import { crearVenaScrap } from "@/utils/api_vena_scrap";

/**
 * Envía el reporte de Consumo de Materia Prima al back.
 * Recibe el payload de buildPayload() y devuelve el registro creado.
 * En caso de error de validación (400), relanza el error para que
 * el componente pueda mostrar los mensajes al usuario.
 *
 * @param {object} payload
 * @returns {{ id, fecha, hora, folio_generado_por_back, ... }}
 */
export const crearReporteVenaScrap = async (payload) => {
  const data = await crearVenaScrap(payload);

  const year  = String(new Date().getFullYear()).slice(-2);
  const folio = `CMP-${year}-${String(data.id).padStart(4, "0")}`;

  return {
    folio,
    submittedAt: new Date().toISOString(),
  };
};